import styled from 'styled-components';
import { Avatar } from 'antd';
import { mainTheme } from 'constant';

export const CustomAvatar = styled(Avatar)`
    background-color: ${mainTheme.primary};;
`;
